module.exports = __webpack_public_path__ + "img/expodecor_pebble.c3bbc5b4.jpg";